var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { sm: "12" } },
        [
          _c("w-input", {
            attrs: { label: _vm.$ct("project-number"), fancy: "" },
            model: {
              value: _vm.project.ComputedFriendlyID,
              callback: function ($$v) {
                _vm.$set(_vm.project, "ComputedFriendlyID", $$v)
              },
              expression: "project.ComputedFriendlyID",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { sm: "12" } },
        [
          _c("w-textarea-autogrow", {
            attrs: { label: _vm.$ct("description"), fancy: "" },
            model: {
              value: _vm.project.Description,
              callback: function ($$v) {
                _vm.$set(_vm.project, "Description", $$v)
              },
              expression: "project.Description",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }